import { projectDataType } from ".";

const waysOfSomethingData: projectDataType = {
  path: "waysofsomething",
  title: "Ways of Something, Episode 1, Minute #22",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964703/Art-Site/WaysOfSomething/screen_shot_2014-03-04_at_80518_pm-frontcrop_z0jdag.jpg",
  description:
    "`Ways of Something`, is a contemporary remake of John Berger’s BBC documentary, `Ways of Seeing` (1972). Commissioned by The One Minutes, at the Sandberg Instituut in Amsterdam and compiled by Lorna Mills, the first episode consists of one-minute videos by 30 web-based artists who commonly work with 3D rendering, gifs, film remix, webcam performances, and websites to describe the cacophonous conditions of artmaking after the internet. Giselle Zatonyl is minute #22. In 2017, The Whitney Museum of American Art acquired Ways of Something for their permanent collection.",
  year: 2016,
  videos: ["https://vimeo.com/112001426", "https://vimeo.com/105731173"],
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964705/Art-Site/WaysOfSomething/screen_shot_2014-03-04_at_80432_pm-u9947-fr_ii0cnb.png",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964703/Art-Site/WaysOfSomething/screen_shot_2014-03-04_at_80518_pm-frontcrop_z0jdag.jpg",
  ],
};

export default waysOfSomethingData;
